import { useToast } from '@chakra-ui/react';
import { useMutation } from 'urql';

import { showAlertDialog } from '../../../shared/components/alert-dialog';
import { DeleteUserMutation } from '../userOperations';

export const useDeleteUser = () => {
  const toast = useToast();
  const [, deleteUser] = useMutation(DeleteUserMutation);

  return (userId: string, onSuccess?: () => void) => {
    showAlertDialog({
      alertType: 'confirm',
      isOpen: true,
      headerText: 'Are you sure you want to delete this user?',
      bodyContent: (
        <span>
          Deleting this user will remove their access to the dashboard. You can
          add them back later if needed.
        </span>
      ),
      footerAcceptIsDestructive: true,
      footerAcceptText: 'Yes, Delete',
      onAccept: async () => {
        deleteUser({ id: userId }).then((result) => {
          if (result.error) {
            toast({
              title: 'Error',
              description: 'There was an error deleting the account',
              status: 'error',
              duration: 4000,
              position: 'top-right',
            });
            return;
          }

          toast({
            title: 'Account deleted',
            description: 'The account has now been deleted',
            status: 'success',
            duration: 4000,
            position: 'top-right',
          });
          onSuccess?.();
        });
      },
    });
  };
};
